import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { UserVarifyService } from '../../services/userVarify.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from '../../providers/alert.service';
import { NavController, ModalController } from 'ionic-angular';
import { RevisePage } from '../password/revise';
import { LoaddingService } from '../../providers/loadding.service';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { AppConfig } from "../../app/app.config";
import { AccountPage } from '../account/account';
@Component({
    selector: 'page-google',
    templateUrl: 'google.html',
    providers: [
        UserVarifyService
    ]
})
export class GooglePage {
    gooleserect: any = '';
    qrCodeImg: any = '';
    GoogleParams = { isShow: false, code: '' };
    code = new Array(6);
    photos = [];
    key;
    url;
    imgSrc:string;
    googleCkParams = { isShow: false, "pwd": "", "chkSign": "1" };
    constructor(
        private viewCtrl: ViewController,
        private user: UserVarifyService,
        private alert: AlertService,
        private navCtrl: NavController,
        private sanitizer: DomSanitizer,
        private load: LoaddingService,
        private modalCtrl: ModalController,
        private navParm: NavParams,

    ) {
        
    }

    ionViewDidLoad() {
        this.url = AppConfig.GetUrl();
        this.getkey();
    }
    // 获取key
    getkey() {
        this.user.getQrCodeImg().then(res => {
            this.imgSrc = res.Base64ImgString;
            this.key = res.GASecret;
        });
    }
    // 绑定谷歌验证器
    addGasecret() {
        let load = this.load.showLoding();
        this.user.addGasecret({
            secret: this.key, key: this.GoogleParams.code
        }).then(s => {
            if (s.Result) {
                this.alert.showAlert(s.Error);
                this.navCtrl.push(AccountPage)
            }
            else this.alert.showAlert(s.Error);
            this.load.closeLoading(load);
        })
    }
    inputChange() {
        let inputVal = this.GoogleParams.code;
        const temp = inputVal.split('');
        this.code = [, , , , , ,];
        for (let i = 0; i < temp.length; i++) {
            this.code[i] = temp[i];
        }
    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/google/google.ts